import Game from "../../Game";
import CustomSlider from "../../entities/UI/CustomSlider/CustomSlider";
import { rootEventBus, EnumRootEventBus } from "../../managers/RootEventBus";
import { Coord, SliderGenProps } from "../../types/Interface";
import { generateSliderProps, getSliderCoords } from "./helpers/sliderHelpers";
import { showSlidersAnim } from "../../animation/Circle/helpers/drawHelpers";


export default class BaseSliderManager {
  private Game = Game.getInstance();
  rootEventBus = rootEventBus;
  EnumRootEventBus = EnumRootEventBus;
  sliders: CustomSlider[] = [];
  slidersProps: SliderGenProps[] = [];
  dim = this.Game.getDim();

  constructor(slidersProps: SliderGenProps[], SLIDERS_COORD: Coord[], SLIDERS_COORD_OFFSET_VERTICAL: Coord[]) {
    this.slidersProps = slidersProps;

    this.generateSliders(SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);

    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
  }
  getSliders = () => this.sliders;
  private setAllVisible(v: boolean) {
    this.sliders.forEach(slider => slider.setSliderVisible(v))
    v && showSlidersAnim(this);
  }
  private generateSliders(SLIDERS_COORD: Coord[], SLIDERS_COORD_VERTICAL: Coord[]) {
    const coords = getSliderCoords(this.dim, SLIDERS_COORD, SLIDERS_COORD_VERTICAL);
    coords.forEach((coord: Coord, cI: number) => {
      const sProps = this.slidersProps[cI];
      const slider = this.addSlider(coord, sProps, sProps.onUpdate);
      this.sliders.push(slider)
    })
  }
  private addSlider(coord: Coord, sGProps: SliderGenProps, onUpdate: (v: number) => void) {
    const props = generateSliderProps(coord, sGProps.head, sGProps.colors, sGProps.subHead, sGProps.keepCurrSlider);
    return new CustomSlider(props, onUpdate);
  }
}